<template>
  <v-container fluid class="ma-0 pa-0">
    <v-row class="ma-0 pa-0">
      <v-col cols="12" md="6">
        <v-card class="elevation-2">
          <v-card-title>Top 10 Clienti per Importo</v-card-title>
          <v-card-text style="height: 400px;">
            <doughnut-chart :data="graficoTopClienti" :options="opzioniTorta" :key="keyTop" />
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card class="elevation-2">
          <v-card-title>Distribuzione Importi</v-card-title>
          <v-card-text>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Cliente</th>
                    <th class="text-right">Importo</th>
                    <th class="text-right">% sul totale</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(cliente, i) in topClientiTabella" :key="i">
                    <td>{{ cliente.cliente }}</td>
                    <td class="text-right">€ {{ $functions.numberWithCommas(cliente.importo.toFixed(2)) }}</td>
                    <td class="text-right">{{ cliente.percentuale.toFixed(1) }}%</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="ma-0 pa-0 mt-3">
      <v-col cols="12">
        <v-card class="elevation-2">
          <v-card-title>
            Matrice Importo Mensile per Cliente
            <v-spacer />
            <v-text-field v-model="ricercaHeatmap" append-icon="search" label="Cerca cliente" single-line hide-details
              dense style="max-width: 300px;" />
          </v-card-title>
          <v-card-text>
            <div class="heatmap-container" style="overflow-x: auto;">
              <table class="heatmap-table">
                <thead>
                  <tr>
                    <th class="text-left sticky-col">Cliente</th>
                    <th v-for="m in 12" :key="m">{{ getNomeMese(m - 1) }}</th>
                    <th class="font-weight-bold">Totale</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="cliente in heatmapFiltrato" :key="cliente.codAnagrafica">
                    <td class="font-weight-bold sticky-col">{{ cliente.cliente }}</td>
                    <td v-for="(val, i) in cliente.mesi" :key="i"
                      :style="{ backgroundColor: getColoreHeat(val, cliente.max) }" class="text-center">
                      {{ val > 0 ? formattaValuta(val) : '-' }}
                    </td>
                    <td class="font-weight-bold text-right">{{ formattaValuta(cliente.totale) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { get_top_clienti_ore, get_heatmap_clienti_ore } from "@/api/api.clienti.js";
import DoughnutChart from "@/components/chart/DoughnutChart.js";
import mixinCharts from "@/components/chart/mixinCharts.js";

export default {
  name: "TabComposizioneOre",

  components: {
    DoughnutChart
  },

  mixins: [mixinCharts],

  props: {
    filtri: { type: Object, default: () => ({}) },
    aggiornaDati: { type: Number, default: 0 }
  },

  data: () => ({
    graficoTopClienti: {},
    opzioniTorta: {},
    keyTop: 0,

    topClientiTabella: [],
    datiHeatmap: [],
    ricercaHeatmap: ''
  }),

  computed: {
    heatmapFiltrato() {
      if (!this.ricercaHeatmap) return this.datiHeatmap;

      const cerca = this.ricercaHeatmap.toLowerCase();
      return this.datiHeatmap.filter(c =>
        c.cliente.toLowerCase().includes(cerca)
      );
    }
  },

  methods: {
    async caricaDatiTopClienti() {
      try {
        let res = await get_top_clienti_ore(this.filtri);

        if (res && res.data) {
          const labels = res.data.map(c => c.cliente);
          const importi = res.data.map(c => c.importo);
          const totale = importi.reduce((a, b) => a + b, 0);

          this.graficoTopClienti = {
            labels: labels,
            datasets: [{
              data: importi,
              backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF',
                '#FF9F40', '#4BC0C0', '#9966FF', '#C9CBCF', '#FF6384']
            }]
          };

          this.topClientiTabella = res.data.map(c => ({
            cliente: c.cliente,
            importo: c.importo,
            percentuale: totale > 0 ? (c.importo / totale) * 100 : 0
          }));

          this.keyTop++;
        }

      } catch (error) {
        console.error("Errore caricamento top clienti:", error);
      }
    },

    async caricaDatiHeatmap() {
      try {
        let res = await get_heatmap_clienti_ore(this.filtri);

        if (res && res.data) {
          this.datiHeatmap = res.data.map(cliente => {
            const totale = cliente.mesi.reduce((a, b) => a + b, 0);
            const max = Math.max(...cliente.mesi);

            return {
              codAnagrafica: cliente.codAnagrafica,
              cliente: cliente.cliente,
              mesi: cliente.mesi,
              totale: totale,
              max: max
            };
          });
        }

      } catch (error) {
        console.error("Errore caricamento heatmap:", error);
      }
    },

    getNomeMese(indice) {
      const mesi = ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'];
      return mesi[indice];
    },

    getColoreHeat(valore, max) {
      if (valore === 0) return '#f5f5f5';
      const intensita = valore / max;
      const r = Math.floor(76 + (255 - 76) * (1 - intensita));
      const g = Math.floor(175 + (255 - 175) * (1 - intensita));
      const b = Math.floor(80 + (255 - 80) * (1 - intensita));
      return `rgba(${r}, ${g}, ${b}, 0.7)`;
    },

    formattaValuta(valore) {
      return '€' + this.$functions.numberWithCommas(valore.toFixed(0));
    },

    caricaTuttiDati() {
      this.caricaDatiTopClienti();
      this.caricaDatiHeatmap();
    }
  },

  mounted() {
    this.opzioniTorta = this.getOptionsDoughnutChart();
    this.caricaTuttiDati();
  },

  watch: {
    aggiornaDati() {
      this.caricaTuttiDati();
    }
  }
}
</script>